export default __webpack_public_path__ + "static/media/meal-3.6d3bae14.svg";